/** Precificação dos exames — integração com a API. */

import apiClient from './apiClient';
import type {
  ConfiguracaoDePreco,
  ExamePrecificado,
  PrecoCalculado,
} from '../types/pricing';

export * from '../types/pricing';

const BASE = '/precificacao';

export const pricingService = {
  async configuracao(): Promise<ConfiguracaoDePreco> {
    const { data } = await apiClient.get<ConfiguracaoDePreco>(`${BASE}/configuracao`);
    if (!data) throw new Error('Configuração de preço não encontrada');
    return data;
  },

  async salvarConfiguracao(dados: {
    taxPercentage?: number;
    profitMarginPercentage?: number;
    roundUpToNearest?: number;
  }): Promise<ConfiguracaoDePreco> {
    const { data } = await apiClient.put<ConfiguracaoDePreco>(`${BASE}/configuracao`, dados);
    if (!data) throw new Error('Resposta vazia do servidor ao salvar a configuração');
    return data;
  },

  async simular(entrada: {
    custo: number;
    impostoPercentual: number;
    margemPercentual: number;
    arredondarPara?: number;
  }): Promise<PrecoCalculado> {
    const { data } = await apiClient.post<PrecoCalculado>(`${BASE}/simular`, entrada);
    if (!data) throw new Error('Resposta vazia do servidor ao simular');
    return data;
  },

  async tabelaDaClinica(providerId: string | number): Promise<{
    configuracao: ConfiguracaoDePreco;
    itens: ExamePrecificado[];
  }> {
    const { data } = await apiClient.get<{
      configuracao: ConfiguracaoDePreco;
      itens: ExamePrecificado[];
    }>(`${BASE}/clinicas/${providerId}`);
    if (!data) throw new Error('Tabela de preços não encontrada');
    return data;
  },

  async aplicarPrecos(
    providerId: string | number
  ): Promise<{ atualizados: number; semCusto: number }> {
    const { data } = await apiClient.post<{ atualizados: number; semCusto: number }>(
      `${BASE}/clinicas/${providerId}/aplicar`,
      {}
    );
    if (!data) throw new Error('Resposta vazia do servidor ao aplicar os preços');
    return data;
  },
};

export default pricingService;
